import React, { useEffect, useState } from 'react';

import { HStack, Stack } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Card, PageHeaderWithIcon } from 'components/DataDisplay';
import { BorderedBox } from 'components/DataDisplay/Box/BorderedBox';
import { FilterLabelWrapper } from 'components/DataDisplay/Box/BorderedBox/FilterLabelWrapper';
import { LearnMore } from 'components/DataDisplay/KnowledgeBase/Components/LearnMore';
import { useKnowledgeBase } from 'components/DataDisplay/KnowledgeBase/hook/useKnowledgeBase';
import { AddButton, ButtonGroup, ButtonGroupItem } from 'components/DataEntry';
import { LearnMoreButton } from 'components/DataEntry/Button/LearnMoreButton';
import { ActivityIcon } from 'components/Icons';
import { useSearchParamFunctions } from 'containers/App/hooks/useSearchParamFunctions';
import { actions } from 'containers/Visibility/IncidentResponse/slice';
import { useSearchParams } from 'hooks/useSearchParams';

import { selectIncidentResponse } from '../selectors';
import { CloudEventsViewByTabs } from '../types';

import { ActivityGroupsTable } from './Data/ActivityGroups/ActivityGroupsTable';
import { cloudEventsViewByItems } from './utils';

export const CloudEvents: React.FC = () => {
  const params = useSearchParams<{
    tab: string;
    resource_type: string;
    contexts: string;
  }>();
  const { updateValueInURL } = useSearchParamFunctions();
  const dispatch = useDispatch();
  const { setLearnMore } = useKnowledgeBase();
  const { activityGroups } = useSelector(selectIncidentResponse);
  const [viewBy, setViewBy] = useState<ButtonGroupItem>(
    cloudEventsViewByItems[0],
  );
  const navigate = useNavigate();

  //set viewBy
  useEffect(() => {
    if (!!params.tab) {
      setViewBy(
        params.tab === CloudEventsViewByTabs.Identity
          ? cloudEventsViewByItems[1]
          : params.tab === CloudEventsViewByTabs.Network
          ? cloudEventsViewByItems[2]
          : cloudEventsViewByItems[0],
      );
    }
  }, [params.tab]);

  // Load activity groups
  useEffect(() => {
    if (viewBy.value !== CloudEventsViewByTabs.Data) return;

    dispatch(
      actions.getActivityGroups({
        q: {
          offset:
            (activityGroups.page.info.page_number - 1) *
            activityGroups.page.info.page_size,
          limit: activityGroups.page.info.page_size,
        },
      }),
    );
  }, [
    activityGroups.page.info.page_number,
    activityGroups.page.info.page_size,
    dispatch,
    viewBy.value,
  ]);

  return (
    <Card>
      <Stack spacing={2} h="full" w="full">
        <HStack>
          <PageHeaderWithIcon label="Cloud Events" icon={<ActivityIcon />} />
        </HStack>
        <HStack justify="space-between" w="full" pt={2} pb={3}>
          <HStack>
            <FilterLabelWrapper>VIEW BY</FilterLabelWrapper>
            <ButtonGroup
              items={cloudEventsViewByItems}
              value={viewBy}
              onClick={item => {
                setViewBy(item);
                updateValueInURL('tab', item.value);
              }}
            />
          </HStack>
          <HStack>
            <LearnMoreButton
              onOpen={() => setLearnMore('activity_group')}
              label="Activity Group"
            />
            <AddButton
              onClick={() => navigate('/visibility/activity/group/add')}
              label="Create Activity Group"
            />
          </HStack>
        </HStack>

        <BorderedBox w="full" h="full" p={4}>
          <ActivityGroupsTable />
        </BorderedBox>
      </Stack>
      <LearnMore />
    </Card>
  );
};
